import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Breadcrumb, Row, Col, Pagination, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

import AdminJobList from "./AdminJobList";

const routes = [
  { path: "", breadcrumbName: "App" },
  { path: "/jobs", breadcrumbName: "Jobs" },
];

const AdminJob = () => {
  const [adminJobs, setAdminJobs] = useState();
  const [pagination, setPagination] = useState({ currentPage: 1, limit: 10 });

  const fetchAdminJobs = useCallback(async () => {
    const res = await axios.get(`/api/admin-jobs`, {
      params: {
        limit: pagination.limit,
        page: pagination.currentPage,
      },
    });
    setAdminJobs(res.data.data);
    setPagination(res.data.pagination);
  }, [pagination.currentPage, pagination.limit]);

  useEffect(() => {
    fetchAdminJobs();
  }, [fetchAdminJobs]);

  const refresh = () => {
    fetchAdminJobs();
  };

  return (
    <div>
      <div className="header">
        <Row>
          <Col span={12}>
            <h2 className="detail-header-text">Jobs</h2>
          </Col>
          <Col span={12}>
            <Breadcrumb
              style={{ margin: "10px 0", textAlign: "right" }}
              routes={routes}
            />
          </Col>
        </Row>
      </div>

      <Row className="mt-2 mb-2" justify={"end"} align="middle">
        <Button onClick={refresh}>
          <ReloadOutlined />
        </Button>
      </Row>

      {adminJobs && <AdminJobList adminJobs={adminJobs} />}

      <Row justify="end">
        <Col>
          <Pagination
            total={pagination?.totalSize}
            pageSize={pagination?.limit}
            onChange={(currentPage, limit) => {
              setPagination({ ...pagination, limit, currentPage });
            }}
            current={pagination.currentPage}
          />
        </Col>
      </Row>
    </div>
  );
};

export default AdminJob;
